import React from 'react';
import Page1 from '../components/page1';
import OrgSideBar from "../scenes/global/Organization-Sidebar";
const FirstPage = () => {
    return (
        <>
      
         <Page1 />
           

        </>
       
    );
}
export default FirstPage